<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'chip',
  props: ['value']
});
</script>

<template>
  <span class="px-2 py-1 rounded text-white text-xs">{{ value }}</span>
</template>

<style scoped lang="scss">

</style>